function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117.5 60C117.5 91.4802 91.9802 117 60.5 117C29.0198 117 3.5 91.4802 3.5 60C3.5 28.5198 29.0198 3 60.5 3C91.9802 3 117.5 28.5198 117.5 60Z",
  stroke: "white",
  strokeWidth: 6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M117.5 60C117.5 91.4802 91.9802 117 60.5 117C29.0198 117 3.5 91.4802 3.5 60C3.5 28.5198 29.0198 3 60.5 3C91.9802 3 117.5 28.5198 117.5 60Z",
  stroke: "url(#paint0_linear)",
  strokeOpacity: 0.6,
  strokeWidth: 6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.6819 92.4626L62.0992 71.5184L55.5908 75.7392L44.6947 69.6302L30.5 47.7422L67.1102 24L81.3049 45.888L82.4382 58.3282L75.1162 63.0767L88.6988 84.0209C91.0299 87.6155 90.0057 92.4192 86.4112 94.7503C82.8167 97.0814 78.013 96.0572 75.6819 92.4626ZM72.315 65.8857L85.4446 86.1314C86.6102 87.9286 86.0981 90.3305 84.3008 91.496C82.5035 92.6616 80.1017 92.1495 78.9361 90.3522L65.8065 70.1065L72.315 65.8857ZM76.9954 46.3713L46.8937 65.8927L35.8647 48.8861L39.5257 46.5118L43.6705 52.9031L46.1112 51.3203L41.9663 44.929L47.6613 41.2358L50.3626 45.4012L52.8033 43.8184L50.1019 39.653L54.1697 37.0149L61.6828 48.6L64.1235 47.0172L56.6104 35.4321L59.8646 33.3217L64.9718 41.1969L67.4125 39.6141L62.3053 31.7389L65.9663 29.3647L76.9954 46.3713ZM50.2837 68.3171L55.445 71.2108L78.3631 56.3481L77.8262 50.4554L50.2837 68.3171Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 44.625,
  y1: 120,
  x2: 44.625,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E1E0E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

function SvgCeramicCardPaint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeramicCardPaint);
export default __webpack_public_path__ + "static/media/ceramicCardPaint.ef992823.svg";
export { ForwardRef as ReactComponent };